<mat-form-field class="custom__input-outline-datepicker custom__datepicker-range-to-date" appearance="outline">
  <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
    <input matStartDate formControlName="start" [placeholder]="labelStartDate | translate">
    <input matEndDate formControlName="end" [placeholder]="labelEndDate | translate">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon *ngIf="!hasDateSelected" class="material-symbols-rounded fill"
      matDatepickerToggleIcon>calendar_today</mat-icon>
    <mat-icon *ngIf="hasDateSelected" class="material-symbols-rounded fill" matDatepickerToggleIcon
      (click)="$event.stopPropagation(); clearDateRange()">cancel</mat-icon>
  </mat-datepicker-toggle>

  <mat-date-range-picker #picker [calendarHeaderComponent]="customHeader" panelClass="custom-datepicker-panel">
    <mat-datepicker-actions>
      <button mat-button matDatepickerCancel>{{labelCancel | translate}}</button>
      <button mat-button matDatepickerApply (click)="onEventSubmit()">{{labelAccept | translate}}</button>
    </mat-datepicker-actions>
  </mat-date-range-picker>
</mat-form-field>